export default __webpack_public_path__ + "static/media/WorkSans-Regular.e6f572ce.ttf";